/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BlogModule } from './BlogModule';
import {
    BlogModuleFromJSON,
    BlogModuleFromJSONTyped,
    BlogModuleToJSON,
} from './BlogModule';
import type { CareyChatModule } from './CareyChatModule';
import {
    CareyChatModuleFromJSON,
    CareyChatModuleFromJSONTyped,
    CareyChatModuleToJSON,
} from './CareyChatModule';
import type { CareyEmailModule } from './CareyEmailModule';
import {
    CareyEmailModuleFromJSON,
    CareyEmailModuleFromJSONTyped,
    CareyEmailModuleToJSON,
} from './CareyEmailModule';
import type { CorporateProgramModule } from './CorporateProgramModule';
import {
    CorporateProgramModuleFromJSON,
    CorporateProgramModuleFromJSONTyped,
    CorporateProgramModuleToJSON,
} from './CorporateProgramModule';
import type { CycleTrackingModule } from './CycleTrackingModule';
import {
    CycleTrackingModuleFromJSON,
    CycleTrackingModuleFromJSONTyped,
    CycleTrackingModuleToJSON,
} from './CycleTrackingModule';
import type { DynacareModule } from './DynacareModule';
import {
    DynacareModuleFromJSON,
    DynacareModuleFromJSONTyped,
    DynacareModuleToJSON,
} from './DynacareModule';
import type { ExecutiveReportsModule } from './ExecutiveReportsModule';
import {
    ExecutiveReportsModuleFromJSON,
    ExecutiveReportsModuleFromJSONTyped,
    ExecutiveReportsModuleToJSON,
} from './ExecutiveReportsModule';
import type { FaxModule } from './FaxModule';
import {
    FaxModuleFromJSON,
    FaxModuleFromJSONTyped,
    FaxModuleToJSON,
} from './FaxModule';
import type { GrandfatheredUpdatesModule } from './GrandfatheredUpdatesModule';
import {
    GrandfatheredUpdatesModuleFromJSON,
    GrandfatheredUpdatesModuleFromJSONTyped,
    GrandfatheredUpdatesModuleToJSON,
} from './GrandfatheredUpdatesModule';
import type { PpuPromoModule } from './PpuPromoModule';
import {
    PpuPromoModuleFromJSON,
    PpuPromoModuleFromJSONTyped,
    PpuPromoModuleToJSON,
} from './PpuPromoModule';
import type { ReferralProgramModule } from './ReferralProgramModule';
import {
    ReferralProgramModuleFromJSON,
    ReferralProgramModuleFromJSONTyped,
    ReferralProgramModuleToJSON,
} from './ReferralProgramModule';
import type { SesModule } from './SesModule';
import {
    SesModuleFromJSON,
    SesModuleFromJSONTyped,
    SesModuleToJSON,
} from './SesModule';
import type { SmsModule } from './SmsModule';
import {
    SmsModuleFromJSON,
    SmsModuleFromJSONTyped,
    SmsModuleToJSON,
} from './SmsModule';
import type { StripeModule } from './StripeModule';
import {
    StripeModuleFromJSON,
    StripeModuleFromJSONTyped,
    StripeModuleToJSON,
} from './StripeModule';
import type { TwoFactorAuthenticationModule } from './TwoFactorAuthenticationModule';
import {
    TwoFactorAuthenticationModuleFromJSON,
    TwoFactorAuthenticationModuleFromJSONTyped,
    TwoFactorAuthenticationModuleToJSON,
} from './TwoFactorAuthenticationModule';

/**
 * 
 * @export
 * @interface TenantModules
 */
export interface TenantModules {
    /**
     * 
     * @type {DynacareModule}
     * @memberof TenantModules
     */
    dynacare?: DynacareModule;
    /**
     * 
     * @type {FaxModule}
     * @memberof TenantModules
     */
    fax?: FaxModule;
    /**
     * 
     * @type {SmsModule}
     * @memberof TenantModules
     */
    sms?: SmsModule;
    /**
     * 
     * @type {BlogModule}
     * @memberof TenantModules
     */
    blog?: BlogModule;
    /**
     * 
     * @type {TwoFactorAuthenticationModule}
     * @memberof TenantModules
     */
    twoFactorAuth?: TwoFactorAuthenticationModule;
    /**
     * 
     * @type {SesModule}
     * @memberof TenantModules
     */
    ses?: SesModule;
    /**
     * 
     * @type {StripeModule}
     * @memberof TenantModules
     */
    stripe?: StripeModule;
    /**
     * 
     * @type {CycleTrackingModule}
     * @memberof TenantModules
     */
    cycleTracking?: CycleTrackingModule;
    /**
     * 
     * @type {CareyChatModule}
     * @memberof TenantModules
     */
    careyChat?: CareyChatModule;
    /**
     * 
     * @type {CareyEmailModule}
     * @memberof TenantModules
     */
    careyEmail?: CareyEmailModule;
    /**
     * 
     * @type {ReferralProgramModule}
     * @memberof TenantModules
     */
    referralProgram?: ReferralProgramModule;
    /**
     * 
     * @type {PpuPromoModule}
     * @memberof TenantModules
     */
    ppuPromo?: PpuPromoModule;
    /**
     * 
     * @type {GrandfatheredUpdatesModule}
     * @memberof TenantModules
     */
    grandfatheredUpdates?: GrandfatheredUpdatesModule;
    /**
     * 
     * @type {CorporateProgramModule}
     * @memberof TenantModules
     */
    corporateProgram?: CorporateProgramModule;
    /**
     * 
     * @type {ExecutiveReportsModule}
     * @memberof TenantModules
     */
    executiveReports?: ExecutiveReportsModule;
}

/**
 * Check if a given object implements the TenantModules interface.
 */
export function instanceOfTenantModules(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantModulesFromJSON(json: any): TenantModules {
    return TenantModulesFromJSONTyped(json, false);
}

export function TenantModulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantModules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dynacare': !exists(json, 'dynacare') ? undefined : DynacareModuleFromJSON(json['dynacare']),
        'fax': !exists(json, 'fax') ? undefined : FaxModuleFromJSON(json['fax']),
        'sms': !exists(json, 'sms') ? undefined : SmsModuleFromJSON(json['sms']),
        'blog': !exists(json, 'blog') ? undefined : BlogModuleFromJSON(json['blog']),
        'twoFactorAuth': !exists(json, 'twoFactorAuth') ? undefined : TwoFactorAuthenticationModuleFromJSON(json['twoFactorAuth']),
        'ses': !exists(json, 'ses') ? undefined : SesModuleFromJSON(json['ses']),
        'stripe': !exists(json, 'stripe') ? undefined : StripeModuleFromJSON(json['stripe']),
        'cycleTracking': !exists(json, 'cycleTracking') ? undefined : CycleTrackingModuleFromJSON(json['cycleTracking']),
        'careyChat': !exists(json, 'careyChat') ? undefined : CareyChatModuleFromJSON(json['careyChat']),
        'careyEmail': !exists(json, 'careyEmail') ? undefined : CareyEmailModuleFromJSON(json['careyEmail']),
        'referralProgram': !exists(json, 'referralProgram') ? undefined : ReferralProgramModuleFromJSON(json['referralProgram']),
        'ppuPromo': !exists(json, 'ppuPromo') ? undefined : PpuPromoModuleFromJSON(json['ppuPromo']),
        'grandfatheredUpdates': !exists(json, 'grandfatheredUpdates') ? undefined : GrandfatheredUpdatesModuleFromJSON(json['grandfatheredUpdates']),
        'corporateProgram': !exists(json, 'corporateProgram') ? undefined : CorporateProgramModuleFromJSON(json['corporateProgram']),
        'executiveReports': !exists(json, 'executiveReports') ? undefined : ExecutiveReportsModuleFromJSON(json['executiveReports']),
    };
}

export function TenantModulesToJSON(value?: TenantModules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dynacare': DynacareModuleToJSON(value.dynacare),
        'fax': FaxModuleToJSON(value.fax),
        'sms': SmsModuleToJSON(value.sms),
        'blog': BlogModuleToJSON(value.blog),
        'twoFactorAuth': TwoFactorAuthenticationModuleToJSON(value.twoFactorAuth),
        'ses': SesModuleToJSON(value.ses),
        'stripe': StripeModuleToJSON(value.stripe),
        'cycleTracking': CycleTrackingModuleToJSON(value.cycleTracking),
        'careyChat': CareyChatModuleToJSON(value.careyChat),
        'careyEmail': CareyEmailModuleToJSON(value.careyEmail),
        'referralProgram': ReferralProgramModuleToJSON(value.referralProgram),
        'ppuPromo': PpuPromoModuleToJSON(value.ppuPromo),
        'grandfatheredUpdates': GrandfatheredUpdatesModuleToJSON(value.grandfatheredUpdates),
        'corporateProgram': CorporateProgramModuleToJSON(value.corporateProgram),
        'executiveReports': ExecutiveReportsModuleToJSON(value.executiveReports),
    };
}

